import { useEffect, useState } from "react";
import { getAllTransactions } from "../services/admin.transaction.service";
import TransactionHeader from "../components/transaction/TransactionHeader";
import TransactionTable from "../components/transaction/TransactionTable";
import TransactionDetailsModal from "../components/transaction/TransactionDetailsModal";
import { useToast } from "../context/ToastContext";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Transactions() {
  const { showToast } = useToast();

  const [data, setData] = useState({
    data: [],
    last_page: 1,
    current_page: 1,
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("all");

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    loadTransactions();
  }, [page, search, typeFilter, dateFilter]);

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= data.last_page; i++) {
      pages.push(
        <button
          key={i}
          className={`pageNumber ${page === i ? "active" : ""}`}
          onClick={() => handlePageChange(i)}
          disabled={loading}
        >
          {i}
        </button>,
      );
    }
    return pages;
  };
  async function loadTransactions() {
    setLoading(true);
    try {
      const filters = {
        search,
        type: typeFilter,
        date: dateFilter,
      };

      const response = await getAllTransactions(page, filters);
      setData(response);
    } catch (err) {
      showToast("Erreur de récupération", "error");
    } finally {
      setLoading(false);
    }
  }

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= data.last_page) {
      setPage(newPage);
      window.scrollTo(0, 0);
    }
  };
  if (loading && data.data.length === 0) {
    return (
      <div className="loaderContainer">Chargement des transactions...</div>
    );
  }
  return (
    <div className="page">
      <TransactionHeader
        total={data.total}
        search={search}
        onSearch={(val) => {
          setSearch(val);
          setPage(1);
        }}
        typeFilter={typeFilter}
        onTypeChange={(val) => {
          setTypeFilter(val);
          setPage(1);
        }}
        dateFilter={dateFilter}
        onDateChange={(val) => {
          setDateFilter(val);
          setPage(1);
        }}
      />

      <TransactionTable
        transactions={data.data}
        onView={setSelected}
        loading={loading}
      />
       <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"x    
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>

      {/* <div className="paginationContainer">
        <div className="pagiInfo">
         Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"
            disabled={page === 1 || loading}
            onClick={() => handlePageChange(page - 1)}
          >
            <ChevronLeft size={18} /> Précédent
          </button>

          <div className="pageStatus">
            Page <strong>{data.current_page}</strong> sur{" "}
            <strong>{data.last_page}</strong>
          </div>

          <button
            className="pagiBtn"
            disabled={page === data.last_page || loading}
            onClick={() => handlePageChange(page + 1)}
          >
            Suivant <ChevronRight size={18} />
          </button>
        </div>
      </div> */}
      <TransactionDetailsModal
        tr={selected}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}
